import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useHeader } from './../../components/HeaderContext';
import { useAxiosPrivate } from "./../../hooks/useAxiosPrivate";
import useAuth from "./../../hooks/useAuth.js";
import { useAlert } from './../../components/AlertContext.jsx';
import { format } from "date-fns";

const GroupsEdit = () => {

    const { id } = useParams();

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const { auth } = useAuth();
    const axiosPrivate = useAxiosPrivate();

    const ReturnPage = "/groups";
    const Utilizador = auth.user ? auth.user : "nodejs";

    const { triggerAlert } = useAlert();

    // texto do cabeçalho da pagina
    const { setHeader } = useHeader();
    useEffect(() => {
        setHeader("Edit Group");
    }, [setHeader]);


    const last_modified_date = format(Date(), "dd-MM-yyyy HH:mm:ss");
    const last_modified_user_id = auth.user_id ? auth.user_id : 0;

    //para guardar os valores dos campos
    const [formData, setFormData] = useState({
        group_id: '',
        group_name: '',
        description: '',
        company_id: '',
        last_modified_date: last_modified_date,
        last_modified_user_id: last_modified_user_id
    })

    const navigate = useNavigate();

    useEffect(() => {
        // Fetch data when component mounts
        fetchDataForForm();
    }, [])

    const fetchDataForForm = async () => {
        try {
            console.log("useEffect");
            console.log(id);
            await axiosPrivate.get(`${baseURL}/groups/` + id)
                .then(result => {
                    console.log("groups_edit.js > fetchDataForForm > result.data: ", result.data);

                    setFormData({
                        ...formData, company_id: result.data.company_id,
                        group_id: result.data.group_id,
                        group_name: result.data.group_name,
                        description: result.data.description,
                        last_modified_date: result.data.last_modified_date ? result.data.last_modified_date.substring(0, 10) + " " + result.data.last_modified_date.substring(11, 19) : '',
                        last_modified_user_id: result.data.last_modified_user_id
                    });
                })
        } catch (error) {
            console.error('Error fetching form data:', error);
        }
    };






    const handleSubmitEdit = async (e) => {
        console.log("handleSubmitEdit");
        e.preventDefault();
        try {

            //nova variavel porque com o update do estado é assincrono, quando chamava o axios.put abaixo a variavel ainda nao estava atualizada
            const updatedFormData = { ...formData, last_modified_user_id: last_modified_user_id }; // Include updated 'utilizador' value

            await axiosPrivate.put(`${baseURL}/groups/` + id, updatedFormData)
                .then(result => {
                    console.log(result.data);

                    let message = `Record Saved!`;
                    triggerAlert(message, 'success');

                    navigate(ReturnPage);
                })
                .catch(err => {
                    if (err.response) {
                        console.log(err.response.data.err.originalError.info.message);
                        let message = `Erro na gravação!  \n ${err.response.data.err.originalError.info.message}`;
                        triggerAlert(message, 'error');
                    }
                    else {
                        let message = `Erro na gravação!`;
                        triggerAlert(message, 'error');
                    }
                })
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    const handleBtnPermissoes = async () => {
        console.log("handleBtnPermissoes");
        console.log("auth: ", auth, "Group: ", auth.groups[0]);

        let grupo = auth.groups[0];  //'oficina';

        try {
            await axiosPrivate.get(`${baseURL}/grupo_permissoes/` + grupo)
                .then(result => {
                    console.log(result)

                })


        } catch (error) {
            console.error('Error fetching form data:', error);
        }
    };


    return (
        <div className="d-flex  align-items-center mt-1">
            <div className="p-2 rounded w-50">
                <form className="row g-1" onSubmit={handleSubmitEdit}>

                    <div className="col-12 interno">
                        <label className="form-label  mt-3 app_font1 required" htmlFor="company_id">company_id</label>
                        <input type="text" name="company_id" className="form-control app_font1 form-control-sm" required disabled
                            value={formData.company_id}
                            onChange={(e) => setFormData({ ...formData, company_id: e.target.value })} />
                    </div>
                    <div className="col-12">
                        <label htmlFor="group_name" className="form-label mt-3 app_font1 required" >Group Name</label>
                        <input type="text" name="group_name" className="form-control form-control-sm app_font1" maxLength="30" required disabled
                            value={formData.group_name}
                            onChange={(e) => setFormData({ ...formData, group_name: e.target.value })} />
                    </div>
                    <div className="col-12">
                        <label htmlFor="description" className="form-label mt-3 app_font1 required">Description</label>
                        <input type="text" name="description" className="form-control form-control-sm app_font1" maxLength="50" required
                            value={formData.description}
                            onChange={(e) => setFormData({ ...formData, description: e.target.value })} />
                    </div>

                    <div className="col-12 interno">
                        <label className="form-label mt-3 app_font1 required" htmlFor="last_modified_date">last_modified_date</label>
                        <input type="text" name="last_modified_date" className="form-control app_font1 form-control-sm" required disabled
                            value={formData.last_modified_date}
                            onChange={(e) => setFormData({ ...formData, last_modified_date: e.target.value })} />
                    </div>
                    <div className="col-12 interno">
                        <label className="form-label mt-3 app_font1 required" htmlFor="last_modified_user_id">last_modified_user_id</label>
                        <input type="text" name="last_modified_user_id" className="form-control app_font1 form-control-sm" required disabled
                            value={formData.last_modified_user_id}
                            onChange={(e) => setFormData({ ...formData, last_modified_user_id: e.target.value })} />
                    </div>


                    <div className="mt-3">
                        <button type='submit' className="btn btn-success" style={{ marginRight: '20px', marginTop: '10px' }}>Save</button>
                        <button className="btn btn-outline-success" style={{ marginRight: '20px', marginTop: '10px' }} onClick={() => navigate(ReturnPage)}>Cancel</button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default GroupsEdit